// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"stripeWithdraw__gradient-bg5__xRBbX"};